import {
  GET_DOCUMENT_TYPES,
  GET_DOCUMENT_TYPES_FAIL,
  GET_DOCUMENT_TYPES_SUCCESS,
  ADD_NEW_DOCUMENT_TYPE,
  ADD_DOCUMENT_TYPE_SUCCESS,
  ADD_DOCUMENT_TYPE_FAIL,
  UPDATE_DOCUMENT_TYPE,
  UPDATE_DOCUMENT_TYPE_SUCCESS,
  UPDATE_DOCUMENT_TYPE_FAIL,
  DELETE_DOCUMENT_TYPE,
  DELETE_DOCUMENT_TYPE_SUCCESS,
  DELETE_DOCUMENT_TYPE_FAIL,
  
} from "./actionTypes";

export const getDocumentTypes = () => ({
  type: GET_DOCUMENT_TYPES,
})

export const getDocumentTypesSuccess = documentTypes => ({
  type: GET_DOCUMENT_TYPES_SUCCESS,
  payload: documentTypes,
})

export const getDocumentTypesFail = error => ({
  type: GET_DOCUMENT_TYPES_FAIL,
  payload: error,
})

export const addNewDocumentType = data => ({
  type: ADD_NEW_DOCUMENT_TYPE,
  payload: data,
})

export const addDocumentTypeSuccess = documentType => ({
  type: ADD_DOCUMENT_TYPE_SUCCESS,
  payload: documentType,
})

export const addDocumentTypeFail = error => ({
  type: ADD_DOCUMENT_TYPE_FAIL,
  payload: error,
})

export const updateDocumentType = documentType => ({
  type: UPDATE_DOCUMENT_TYPE,
  payload: documentType,
})

export const updateDocumentTypeSuccess = documentType => ({
  type: UPDATE_DOCUMENT_TYPE_SUCCESS,
  payload: documentType,
})

export const updateDocumentTypeFail = error => ({
  type: UPDATE_DOCUMENT_TYPE_FAIL,
  payload: error,
})

export const deleteDocumentType = data => ({
  type: DELETE_DOCUMENT_TYPE,
  payload: data,
})

export const deleteDocumentTypeSuccess = data => ({
  type: DELETE_DOCUMENT_TYPE_SUCCESS,
  payload: data,
})

export const deleteDocumentTypeFail = error => ({
  type: DELETE_DOCUMENT_TYPE_FAIL,
  payload: error,
})

